// src/components/Forms/ManagerMandatForm/SuccessMessage.tsx

import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCheck } from '@fortawesome/free-solid-svg-icons'

const SuccessMessage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-10 mt-10">
      <h2 className="text-xl mb-2 text-gray-700">
        Opération réussie <FontAwesomeIcon icon={faCheck} style={{ fontSize: '1.5rem' }} className="text-green-600" />
      </h2>
      <p className="text-gray-700 max-w-xl">
        Votre document a bien été signé et vos informations ont été enregistrées avec succès.
      </p>
    </div>
  )
}

export default SuccessMessage
